import React from "react";
import { Controller } from "react-hook-form";

const CheckboxField = ({ name, label, control }) => (
  <div className="checkbox-field">
    <label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <input
            {...field}
            type="checkbox"
            className="checkbox-input"
          />
        )}
      />
      {label}
    </label>
  </div>
);

export default CheckboxField;
